import { factoryService, getJsonRequest, postFileRequest, getFileRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL, REACT_APP_OPEN_DATA_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets the auth open data token.
 */
export const getAuthOpenData = factoryService(() => getJsonRequest(`${REACT_APP_OPEN_DATA_BASE_URL}/v1/auth/publico`))

/**
 * Gets the open data info.
 */
export const getOpenData = factoryService(({ dni, accessToken }) => {
  const customHeaders = { Authorization: `Bearer ${accessToken}` }

  return getJsonRequest(
    `${REACT_APP_OPEN_DATA_BASE_URL}/v1/organismSupplier/get12MesesVentasProveedor?dni=${normalizeDniSlashes(dni)}`,
    {
      customHeaders,
      isPublic: true
    }
  )
})

/**
 * Gets a seller's enrollment status certificate
 */
export const getSellerFilePDFPrivate = factoryService(({ dni = undefined }) => {
  return getFileRequest(
    `${REACT_APP_API_BASE_URL}/v1/pdf/proveedor/ficha-informacion-general${dni !== undefined ? `/${normalizeDniSlashes(dni)}` : '/'}`
  )
})

/**
 * Gets a hability list
 **/
export const getSellerFilePDFPublic = factoryService(({ dni, token }) => {
  const body = {
    rut: normalizeDniSlashes(dni),
    tokenReCaptcha: token
  }
  return postFileRequest(`${REACT_APP_API_BASE_URL}/v1/pdf/proveedor/publica/ficha-informacion-general`, { body })
})
